import React from 'react';

interface StatusBadgeProps {
  statusName: string;
  language: 'en' | 'ar';
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ statusName, language }) => {
  const getStatusColor = (statusName: string) => {
    const lowerStatus = statusName.toLowerCase();
    if (lowerStatus.includes('draft') || lowerStatus.includes('مسودة')) {
      return 'bg-gray-100 text-gray-800';
    } else if (lowerStatus.includes('progress') || lowerStatus.includes('جاري')) {
      return 'bg-yellow-100 text-yellow-800';
    } else if (lowerStatus.includes('completed') || lowerStatus.includes('مكتمل')) {
      return 'bg-green-100 text-green-800';
    } else if (lowerStatus.includes('archived') || lowerStatus.includes('مؤرشف')) {
      return 'bg-blue-100 text-blue-800';
    }
    return 'bg-gray-100 text-gray-800';
  };

  return (
    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(statusName)}`}>
      {statusName}
    </span>
  );
};

export default StatusBadge;
